import React from "react";
import Icon from "./Icon";
export default function File(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("path", {
    d: "M11.9167 1.83334H5.50008C5.01385 1.83334 4.54754 2.0265 4.20372 2.37031C3.8599 2.71413 3.66675 3.18045 3.66675 3.66668V18.3333C3.66675 18.8196 3.8599 19.2859 4.20372 19.6297C4.54754 19.9735 5.01385 20.1667 5.50008 20.1667H16.5001C16.9863 20.1667 17.4526 19.9735 17.7964 19.6297C18.1403 19.2859 18.3334 18.8196 18.3334 18.3333V8.25001L11.9167 1.83334Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9167 1.83334V8.25001H18.3334"
  }));
}
File.displayname = "File";
//# sourceMappingURL=File.js.map